import get from 'lodash/get';
import capitalize from 'lodash/capitalize';

import getDateStr from './getDateStr';
import getStatus from './getStatus';
import { getTeamOrUserName } from '../ui/getTaemOrUserName';
import { isCompleted } from '../../components/Healthboard/utils';
import { isPreVisitForm } from '../../components/Surveys/utils/preVisitForm';
import {
  ACTIONS,
  SURVEYS_ASSIGNMENT_TITLE,
  SURVEYS_ASSIGNMENT_DESC,
} from '../../constants/strings';
import { formatWithTimezone } from '../converters/dateConverters';

export default (survey, formatMessage, showStatus = true) => {
  if (!get(survey, 'assignmentId')) return {};

  const {
    sentAt,
    status,
    expiredAt,
    assignmentMethod,
    assigner,
    originalAssigner,
    survey: { description, frequency, surveyType, name },
    localCompletedAt,
    completedAtTimezone,
  } = survey;

  const surveyHeading = getSurveyHeaderSubtitle(
    surveyType,
    frequency,
    formatMessage,
    assignmentMethod,
    assigner,
    originalAssigner,
  );

  const heading = `${surveyHeading} ${
    !isPreVisitForm(surveyType) && !isCompleted(status)
      ? getDateStr(sentAt, formatMessage)
      : ''
  }`;

  return {
    sentAt,
    expiredAt,
    description,
    frequency,
    name,
    heading,
    status: getStatus(survey, formatMessage, showStatus),
    date: localCompletedAt
      ? formatWithTimezone(localCompletedAt, completedAtTimezone, formatMessage)
      : null,
  };
};

export function getSurveyHeaderSubtitle(
  surveyType,
  frequency,
  formatMessage,
  method,
  assigner,
  originalAssigner,
) {
  const preVisitTitle = !method
    ? formatMessage({ id: 'surveys.preVisit.preVisitForm' })
    : '';
  const frequencyTitle = !isPreVisitForm(surveyType)
    ? `${capitalize(frequency)} ${formatMessage(ACTIONS.survey.single)}`
    : preVisitTitle;
  const typeTitle = getSurveyAssignmentMethod({
    method,
    assigner,
    formatMessage,
    originalAssigner,
  });

  return [frequencyTitle, typeTitle].filter(str => Boolean(str)).join(', ');
}

export function getSurveyAssignmentMethod({
  method,
  assigner,
  formatMessage,
  showDescription,
  originalAssigner,
}) {
  const assignerName = get(assigner, 'name');
  const originalAssignerName = get(originalAssigner, 'displayableName');
  const name = getTeamOrUserName(assignerName, originalAssignerName);
  const translationId = showDescription
    ? SURVEYS_ASSIGNMENT_DESC
    : SURVEYS_ASSIGNMENT_TITLE;

  return method
    ? formatMessage(translationId[method], { name: name || '' })
    : '';
}



// WEBPACK FOOTER //
// ./src/utils/survey/getSpecification.js